var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prompt-diff-viewer"},_vm._l((_vm.diffLines),function(line,index){return _c('div',{key:index,staticClass:"diff-line",class:_vm.lineClass(line)},[_c('span',{staticClass:"diff-line-text"},[_vm._v(_vm._s(line || ' '))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }